export const instructionFileName = {
    ru: 'Start AWR — инструкция по установке и настройке плагина для Microsoft Outlook.pdf',
    en: 'Start AWR — plugin installation and configuration guide for Microsoft Outlook email client.pdf',
    it: 'Start AWR — Guida per l’installazione e la configurazione per il client di posta elettronica Microsoft.pdf'
};
